import Bottle from 'bottlejs';
import terminusDrilldownContainerFactory from './TerminusDrilldownContainer';
import terminusDrilldownViewFactory from './TerminusDrilldownView';
import terminusDrilldownAddVocabularyFactory from './TerminusDrilldownAddVocabularyContainer';
import terminusDrildownAddVocabularyHelpFactory from './VocabularyDrilldownAddHelp';
import terminusDrilldownData from './TerminusDrilldownData';
import terminusData from '../Terminus/TerminusData';

export default () => {
  const terminusDrilldownBottle = new Bottle();
  terminusData(terminusDrilldownBottle);
  terminusDrilldownContainerFactory(terminusDrilldownBottle);
  terminusDrilldownViewFactory(terminusDrilldownBottle);
  terminusDrilldownData(terminusDrilldownBottle);
  terminusDrilldownAddVocabularyFactory(terminusDrilldownBottle);
  terminusDrildownAddVocabularyHelpFactory(terminusDrilldownBottle);
  return terminusDrilldownBottle;
};
